import { styled } from "@mui/material";
import { Button } from "@kaltura/ds-react-components";

export const StyledTopBanner = styled("div")(({ theme }) => ({
    borderBottom: `1px solid ${theme.kaltura.palette.tone5}`,
    backgroundColor: theme.kaltura.palette.surfaces.background,
    display: "flex",
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    width: "100%",
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
    },
}));

export const StyledTopRow = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: theme.spacing(1),
}));

export const StyledTextContainer = styled("div")(({ theme }) => ({
    flexGrow: 1,
}));

export const StyledButtonsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexShrink: 0,
}));
